/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarContact_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRequestHold_item" | "PdpSharedContactSellerButton_item">;
    readonly " $refType": "PdpRespSidebarContact_item";
};
export type PdpRespSidebarContact_item$data = PdpRespSidebarContact_item;
export type PdpRespSidebarContact_item$key = {
    readonly " $data"?: PdpRespSidebarContact_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestHold_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '222e787c008c0418077eadeb1256389c';
export default node;
